import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1914d824"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center mb-4 flex-row" }
const _hoisted_2 = { class: "text-center fw-bold mb-0 fs-5 pb-2" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "detail-header border-bottom mb-4 pb-4 position-relative" }
const _hoisted_7 = {
  key: 0,
  class: "mb-2 d-flex justify-content-between"
}
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "fs-7 mb-0 text-break" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "fs-7 fw-bold" }
const _hoisted_12 = {
  key: 1,
  class: "pl-0"
}
const _hoisted_13 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onSubmit"]
const _hoisted_17 = { class: "me-lg-3 me-0 mb-4 mb-lg-0 w-100" }
const _hoisted_18 = ["placeholder", "rows"]
const _hoisted_19 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "mb-2 d-flex justify-content-center" }

import { computed, ComputedRef, nextTick, onBeforeMount, onMounted, ref, watch, watchEffect } from 'vue'
import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import MessageItemDirectChat from '../components/MessageItemDirectChat.vue'
import Avatar from '@/components/avatar'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ChatModal from '@/views/user/conversations/components/ChatModal.vue'
import DeleteChatModal from '@/views/user/conversations/components/DeleteChatModal.vue'
import DeleteChatSuccessModal from '@/views/user/conversations/components/DeleteChatSuccessModal.vue'
import Loading from '@/components/loading/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'
import { CHAT_STORE, ROOT_STORE } from '@/store/constants'
import { DirectChatType } from '@/store/modules/chat'

import VirtualList from 'vue3-virtual-scroll-list'
import { useWebSocket } from '@/use/useWebsocket'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import chatService from '@/services/chat.services'
import { customMaxLength, customMinLength } from '@/utils'
import { useChat } from '@/composables/chat'
import { partnerChatDisplayName } from '@/constants/common'
import ChatStar from '../components/ChatStar.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const router = useRouter()
const { connection } = useWebSocket()

const direct_chat = computed<DirectChatType>(() => store.getters[CHAT_STORE.GETTERS.GET_DIRECT_CHAT])
const loading = computed<ComputedRef<DirectChatType>>(() => store.getters[CHAT_STORE.GETTERS.LOADING_CHAT])
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const message = computed(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_SOCKET])
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])
const { idComment, sendMessage, scrollMessage } = useChat()

const rules = computed(() => {
  return {
    content: {
      maxLength: (value: string) => customMaxLength(value, 500),
    },
  }
})

const formData = ref({
  content: '',
})
const virtual_list = ref()

const v$ = useVuelidate(rules, formData)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  isCheckedNGContent.value = false
  await checkNGContent()
  while (!isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyContent.value) return

  store.dispatch(CHAT_STORE.ACTIONS.SEND_MESSAGE_DIRECT, {
    community_id: route.params?.id,
    chatroom_id: route.params?.chatroom_id,
    content: formData.value?.content,
    create_by_admin: isAdminPage.value,
  })
  updateMessageRead()
  sendMessage.value = true
  v$.value.$reset()
  Object.assign(formData.value, {
    content: '',
  })
}

const handleClickBack = (): void => {
  router.go(-1)
}

watch(
  () => message.value,
  () => {
    if (message.value?.chatroom_id === route.params?.chatroom_id) {
      if (message.value?.type === 'create') {
        store.dispatch(CHAT_STORE.ACTIONS.ADD_DIRECT_MESSAGE, message.value)
      }
      if (message.value?.type === 'delete') {
        store.dispatch(CHAT_STORE.ACTIONS.REMOVE_DIRECT_MESSAGE_WS, message.value.id)
      }
    }
  },
  {
    deep: true,
  }
)

const dataLoadMore = ref()

watchEffect(() => {
  dataLoadMore.value = [...direct_chat.value.data]
  dataLoadMore.value.unshift({ id: 'first_chat_page' })
})

watch(
  () => direct_chat.value.data,
  async () => {
    await nextTick()
    const scroller = document.querySelector('.scroller') as HTMLElement
    if (page.value === 1) {
      // not use function scrollToBottom from virtual_list may cause infinite loop
      // await virtual_list.value?.scrollToBottom()
      virtual_list.value.scrollTop = 9999999999
      if (scroller) scrollMessage(scroller, 9999999999)
    } else {
      virtual_list.value.scrollTop = 8000
      if (scroller) scrollMessage(scroller, sendMessage.value ? 9999999999 : 8000)
    }
  },
  {
    deep: true,
  }
)

const getData = ref<boolean>(false)

onMounted(async () => {
  idComment.value = route.query?.target_content_id
  if (route.params?.id) {
    await store.dispatch(CHAT_STORE.ACTIONS.GET_DIRECT_CHAT, {
      community_id: route.params?.id,
      chatroom_id: route.params?.chatroom_id,
      create_by_admin: isAdminPage.value,
      page: 1,
      target_content_id: route.query?.target_content_id,
    })
    getData.value = true
  }
})

watchEffect(() => {
  if (!direct_chat.value?.chatroom?.id && getData.value) {
    router.replace('/404')
  }
})

onMounted(() => {
  virtual_list.value = document.querySelector('.scroller')
})

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)

onBeforeRouteLeave(() => {
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 0)
})

const updateMessageRead = async () => {
  try {
    await chatService.updateMessageReadDirect(route.params?.chatroom_id, { create_by_admin: isAdminPage.value })
  } catch (error) {
    console.log(error)
  }
}

const isAdminPage = computed(() => route.path.includes('admin'))

const syncedStar = computed({
  get() {
    return !!direct_chat.value.chatroom.star
  },
  set(newValue: boolean) {
    direct_chat.value.chatroom.star = newValue
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('SM66header')), 1)
    ]),
    (_unref(isAdminPage) && _unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['p-3 p-lg-4 shadow rounded-4 bg-white mb-4 mb-lg-5', { 'hidden-layout': _unref(isAdminPage) && _unref(loading) }])
    }, [
      _createElementVNode("div", _hoisted_6, [
        (_unref(isAdminPage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(Avatar), {
                  is_deleted_in_30_days: _unref(direct_chat)?.chatroom?.is_deleted_in_30_days,
                  user_image_url: _unref(direct_chat)?.chatroom?.image_url,
                  size: 'small',
                  userType: _unref(direct_chat)?.chatroom?.user_type
                }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"]),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(translate)('SM10partner')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(UserAliasIcon, {
                      userType: _unref(direct_chat)?.chatroom?.user_type
                    }, null, 8, ["userType"]),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(partnerChatDisplayName)(_unref(direct_chat)?.chatroom, true)), 1)
                  ])
                ])
              ]),
              _createVNode(ChatStar, {
                star: _unref(syncedStar),
                "onUpdate:star": _cache[0] || (_cache[0] = ($event: any) => (_isRef(syncedStar) ? (syncedStar).value = $event : null)),
                "chatroom-id": _unref(direct_chat)?.chatroom.id,
                class: "mb-3 chat-star"
              }, null, 8, ["star", "chatroom-id"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", null, _toDisplayString(_unref(translate)('chatContent1')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(translate)('chatContent2')), 1)
            ]))
      ]),
      (_unref(loading) && !_unref(isAdminPage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
        : _createCommentVNode("", true),
      _createVNode(_unref(VirtualList), {
        class: "scroller",
        ref: (_value, _refs) => {
          _refs['virtual_list'] = _value
          virtual_list.value = _value
        },
        style: {"height":"540px","overflow-y":"auto","overflow-x":"hidden"},
        "estimate-size": 80,
        keeps: 1000,
        "data-key": 'id',
        "data-sources": dataLoadMore.value,
        "data-component": MessageItemDirectChat,
        "extra-props": { partner_post: _unref(direct_chat).chatroom, is_admin: _unref(route).path.includes('/admin'), id_comment: _unref(idComment) }
      }, null, 8, ["data-sources", "extra-props"]),
      (_unref(direct_chat).chatroom?.can_chat)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _withModifiers(onSubmit, ["prevent"]),
            action: "",
            class: "bg-gray p-3 d-flex form-chat"
          }, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("textarea", {
                placeholder: _unref(translate)('placeholder'),
                name: "content",
                class: _normalizeClass(['form-control p-2 ', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '', _unref(isMobile) ? 'p-1' : 'p-2']),
                rows: _unref(isMobile) ? 1 : 2,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                onBlur: _cache[2] || (_cache[2] = () => (_unref(v$).content.$model = _unref(v$).content.$model.replace(/\n+$/, ''))),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args))),
                onClick: updateMessageRead
              }, null, 42, _hoisted_18), [
                [_vModelText, _unref(v$).content.$model]
              ]),
              (ngKeyContent.value && !_unref(v$).content.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('chatContent'),
                params: [_unref(DEFAULT_MIN_LENGTH), 500],
                validator: _unref(v$).content.$errors[0]?.$validator
              }, null, 8, ["title", "params", "validator"])
            ]),
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  title: _unref(translate)('SO65send'),
                  type: 'secondary',
                  htmlType: 'submit',
                  class: "fw-bold mt-2",
                  disabled: !formData.value.content.trim()
                }, null, 8, ["title", "disabled"]))
              : _createCommentVNode("", true),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: _normalizeClass(['button-mobile', ngKeyContent.value || _unref(v$).content.$error || !formData.value.content.trim() ? '' : 'button-submit']),
                  htmlType: 'submit',
                  disabled: _unref(v$).content.$error || !formData.value.content.trim()
                }, _toDisplayString(_unref(translate)('SO65send')), 11, _hoisted_20))
              : _createCommentVNode("", true)
          ], 40, _hoisted_16))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(Button, {
        title: _unref(isAdminPage) ? _unref(translate)('back') : _unref(translate)('SM65backChatList'),
        type: 'secondary',
        className: "mb-0 mb-lg-3",
        onClick: handleClickBack
      }, null, 8, ["title"])
    ]),
    _createVNode(ChatModal),
    _createVNode(DeleteChatModal, { isDirectChat: true }),
    _createVNode(DeleteChatSuccessModal)
  ], 64))
}
}

})